module.exports = __webpack_public_path__ + "static/media/9.8f5156cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/9.png
// module id = 1378
// module chunks = 0